import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UpdatePrompt.graphql';
import { Mutation, MutationupdatePromptArgs } from '../../__generated__/globalTypes';

export const useUpdatePromptMutation = (options?: MutationHookOptions<Mutation, MutationupdatePromptArgs>) => {
  const [callUpdatePrompt, result] = useMutation<Mutation, MutationupdatePromptArgs>(MUTATION, options);

  return { callUpdatePrompt, ...result };
};

export type UpdatePromptMutationFunction = Mutation['updatePrompt'];
